const styleSheet = () => ({
  dropdown: {
    position: 'absolute',
    maxHeight: '149px',
    width: '244px',
    borderRadius: '4px',
    backgroundColor: 'white',
    zIndex: '100',
    overflowY: 'auto',
  },
  dropdownArrow: {
    position: 'absolute',
    right: '7px',
    top: '5px',
    width: '24px',
    height: '24px',
    marginRight: '1px',
    '& svg': {},
  },
  selected: {
    border: '1.2px solid rgba(8, 95, 229, 0.3)',
  },
  hidden: {
    display: 'none',
  },
  dropdownItem: {
    display: 'flex',
    margin: '4px 0 4px 0',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(8, 95, 229, 0.1)',
    },
  },
  dropdownItemText: {
    width: '230px',
    color: '#085FE5',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '34px',
    paddingLeft: '5px',
  },
  itemEllipsis: {
    // Adding an ellipsis to a long name
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'block', // Need this for the above properties to work.
  },
});

export default styleSheet;
